export default "__VITE_ASSET__c8b28a98__"